import { render } from "./App.vue?vue&type=template&id=66ee78c0&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=66ee78c0&scoped=true&lang=css"

import exportComponent from "/var/www/profixone-instant-clone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ee78c0"]])

export default __exports__